import React, { useContext, useEffect, useState } from 'react';
import { Box, Divider, Typography, Grid } from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { GoogleLoginButton } from 'react-social-login-buttons';
import { signInWithPopup } from 'firebase/auth';
import { getToken, onMessage } from 'firebase/messaging';

import KenButton from '../../../GlobalComponents/KenButton';
import KenInput from '../../../GlobalComponents/KenInput';
import KenLoader from '../../../GlobalComponents/KenLoader';
import { SubTitle } from '../../../GlobalComponents/KenTitle';
import routes from '../../../Utils/routes';
import { getOtp, loginSSO, loginSSORegister, registerDevice } from '../../../Utils/apiService';
import KenSelect from '../../../GlobalComponents/KenSelect';
import { SignUpFormData } from '../../../interfaces/Auth';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import KenPhoneInput from '../../../GlobalComponents/KenPhoneInput';
import { auth, provider } from '../../../firebase/firebase';
import { useStyles } from '../styles';
import { signupForm } from '../../../Utils/FormJsons/signupForm';
import KenTextLabel from '../../../GlobalComponents/KenTextLabel';
import Image from '../../../Assets/assetHelper';
import DefaultBackground from '../../../Assets/loginbackground.svg';
import { messaging } from '../../../firebase/firebase';

interface LoginSSOResponse {
  data?: {
    firstName: string;
    Ken_Alumni_CRM__r: any;
    success: boolean;
    Id: string;
    Name: string;
    Photo__c: string;
    Year_of_Graduation__c: string;
    accessToken?: { token: string };
    refreshToken?: { token: string };
    turbosendToken?: {
      idToken: string;
      refreshToken: string;
    };
  };
  errorMessage?: string;
}

const EmailSignup: React.FunctionComponent = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { dispatch } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const [fcmtoken, setFcmToken] = useState('');
  const [loader, setLoader] = useState<boolean>(false);
  const [isValidMobile, setIsValidMobile] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { handleSubmit, control, clearErrors } = useForm<SignUpFormData>({
    mode: 'onChange',
    defaultValues: {
      ...state,
    },
  });

  // FCM: register service worker & token
  useEffect(() => {
    const registerServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js'
          );
          console.log('Service Worker registered:', registration);

          const token = await getToken(messaging, {
            vapidKey:
              'BLottGqnSSyOuoSisCqGW12IarH10LQUfB_PdbaglRv7ThalvKZNliXFpqfP_RUm0A8WTb_ouyQtp7wToKiy2Ps',
            serviceWorkerRegistration: registration,
          });

          if (token) {
            setFcmToken(token);
            console.log('FCM Token:', token);
          } else {
            console.log('No FCM token available.');
          }
        } catch (error) {
          console.error('Service Worker registration failed:', error);
        }
      }
    };

    registerServiceWorker();
  }, []);

  const registeFCMToken = (userId: string, token: string) => {
    setLoading(true);
    registerDevice({
      userId,
      token: 'Permission Dennied',
    })
      .then((res: any) => {
        if (res) {
          // no-op
        }
      })
      .catch((err) => {
        console.log(err, 'error');
      });
  };

  const onSubmit: SubmitHandler<SignUpFormData> = async (data) => {
    if (isValidMobile) {
      enqueueSnackbar({
        message: 'Please resolve all the error',
        variant: 'error',
        autoHideDuration: 3000,
      });
      return;
    }
    setLoader(true);
    getOtp(data.email, false)
      .then((res: any) => {
        if (res?.success) {
          navigate(routes.otpverification, {
            state: { email: data.email, data: data },
          });
        } else {
          console.log(res?.response?.data?.errorMessage?.errorMessage, 'abcdef');
          enqueueSnackbar({
            message:
              res?.response?.data?.errorMessage?.errorMessage ||
              'An error occurred',
            variant: 'error',
            autoHideDuration: 3000,
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        enqueueSnackbar({
          message: 'Something Went Wrong',
          variant: 'error',
          autoHideDuration: 3000,
        });
        console.error(err);
        setLoader(false);
      });
  };

  const handleGoogleSignIn = async () => {
    setLoading(true);
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    try {
      if (!user || !user.email) {
        enqueueSnackbar({
          message: 'Google authentication failed (no email). Try again.',
          variant: 'error',
        });
        return;
      }

      const email = user.email;
      const response = (await loginSSO(email)) as LoginSSOResponse;

      console.log('loginSSO response:', response);

      if (!response?.data?.success) {
        enqueueSnackbar({
          message: response?.errorMessage || 'Login failed',
          variant: 'error',
        });
        return;
      }

      const resData = response.data;

      if (!resData.accessToken?.token || !resData.refreshToken?.token) {
        enqueueSnackbar({
          message: 'Login response missing tokens. Contact support.',
          variant: 'error',
        });
        return;
      }

      const isActive =
        resData?.Ken_Alumni_CRM__r?.records?.[0]?.Is_Active__c;

      if (!isActive) {
        enqueueSnackbar({
          message:
            'Your account is pending approval. Please wait for admin approval before logging in.',
          variant: 'error',
        });
        return;
      }

      // If you want to log them in immediately, uncomment and adjust:
      // dispatch({
      //   type: 'LOGIN',
      //   payload: {
      //     user: {
      //       applicantEmail: email,
      //       applicantId: resData.Id,
      //       applicantName: resData.firstName,
      //       applicationProfile: resData.Photo__c,
      //       graduationYear: `${resData.Year_of_Graduation__c}`,
      //       accessToken: {
      //         token: resData.accessToken.token,
      //       },
      //       refreshToken: {
      //         token: resData.refreshToken.token,
      //       },
      //       turbosendToken: {
      //         idToken: resData.turbosendToken?.idToken || '',
      //         refreshToken: resData.turbosendToken?.refreshToken || '',
      //       },
      //       applicantFirstName: '',
      //       applicantLastName: '',
      //       status: {
      //         isProfileVerified: false,
      //         isSignupCompleted: false,
      //         isActive: isActive,
      //       },
      //     },
      //   },
      // });

      if (resData.Id && fcmtoken) {
        registeFCMToken(resData.Id, fcmtoken);
      }

      // Navigate to signup / onboarding
      navigate('/signup');
    } catch (error: any) {
      console.error('Google Sign-In Error:', error);

      if (error?.code === 'auth/popup-closed-by-user') {
        enqueueSnackbar({
          message: 'Google sign-in was cancelled by the user.',
          variant: 'warning',
        });
      } else if (error?.code === 'auth/cancelled-popup-request') {
        enqueueSnackbar({
          message:
            'Google sign-in cancelled due to conflicting popup. Try again.',
          variant: 'warning',
        });
      } else {
        const data = {
          email: user.email,
          isGoogleLogin: true,
        };
        await loginSSORegister(data)
          .then((res) => {
            navigate('/signup');
          })
          .catch((err) => {
            console.log(err, 'loginerr');
          });
        enqueueSnackbar({
          message: 'User does not exist.',
          variant: 'error',
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const validatePhoneNumber = (
    inputPhoneNumber: string,
    countryCode: CountryCode
  ) => {
    clearErrors('phone');
    const isValid = isValidPhoneNumber(
      inputPhoneNumber,
      `${countryCode}`.toUpperCase() as CountryCode
    );
    setIsValidMobile(!isValid);
  };

  return (
    <>
      {(loader || loading) && <KenLoader />}   
<>
              <Box className={classes.formContainerLayout}>
                <Typography
                  className={classes.title}
                  style={{ marginTop: '20%' }}
                >
                  Register
                </Typography>
                <Typography>
                  Create your alumni account to get started
                </Typography>

                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className={classes.fieldLayout}
                >
                  <Box mb={2} width="100%">
                    <Controller
                      name="email"
                      control={control}
                      rules={{
                        required: 'Please enter your email address',
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: 'Please enter a valid email address',
                        },
                      }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <Typography className={classes.label}>
                            Email
                          </Typography>
                          <KenInput
                            placeholder="Enter your email"
                            errorMessage={true}
                            hideLabel={true}
                            error={error?.message}
                            InputProps={{ className: classes.inputStyles }}
                            {...field}
                          />
                        </>
                      )}
                    />
                  </Box>

                  <KenButton
                    className={classes.verify}
                    disabled={loader}
                    type="submit"
                    variant="contained"
                  >
                    Register
                  </KenButton>
                </form>

                <Divider sx={{ my: 3 }} />
                <Typography>(or continue with)</Typography>

                <Box display="flex" justifyContent="center" width="100%" mt={2}>
                  <GoogleLoginButton
                    text="Google"
                    onClick={handleGoogleSignIn}
                    iconSize="24px"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      borderRadius: '8px',
                      fontSize: '14px',
                      paddingTop: '5px',
                      paddingBottom: '5px',
                      fontWeight: 500,
                      gap: '8px',
                      width: '100%',
                      lineHeight: '10px',
                      boxSizing: 'border-box',
                    }}
                  />
                </Box>
              </Box>

              <Typography className={classes.accountLink} sx={{ mt: 2 }}>
                Have an account already?{' '}
                <Box
                  component="span"
                  className="anchorLinks"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => navigate(routes.login)}
                >
                  Login
                </Box>
              </Typography>
</>
      
    </>
  );
};

export default EmailSignup;
